var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { key: _vm.postCode, staticClass: "c-table-actions" },
    [
      _c("m-items", {
        attrs: {
          "modal-confirm": true,
          active: _vm.isShowModalRemove,
          "modal-title": "Удаление должности",
          "modal-description": "Подтвердите удаление должности",
          "modal-description-item": _vm.record.name.value,
          "remove-item": _vm.record.code.value,
          "remove-item-type": "post",
        },
        on: { removeItemRequest: _vm.removePost, close: _vm.closeModalRemove },
      }),
      _c("m-alarm", {
        attrs: {
          active: _vm.isShowModalToArchive,
          "position-name": _vm.record.name.value,
          "post-code": _vm.postCode,
        },
        on: {
          close: _vm.closeModalToArchive,
          moveToArchive: _vm.moveToArchive,
          goToEmployeesTable: _vm.goToEmployeesTable,
        },
      }),
      _c("c-button", {
        staticClass: "c-table-actions-menu",
        attrs: {
          id: `bonus-actions-${_vm.postCode}`,
          tabindex: "-1",
          size: "iconic",
          icon: "menu",
        },
      }),
      _vm.record.code.value !== "driver" && Number(_vm.countWorkers) === 0
        ? _c("c-button", {
            directives: [
              {
                name: "b-popover",
                rawName: "v-b-popover.html",
                value: {
                  id: "positions-button-popover",
                  container: "#app",
                  trigger: "hover",
                  content: "Удалить",
                  placement: "top",
                },
                expression:
                  "{\n      id: 'positions-button-popover',\n      container: '#app',\n      trigger: 'hover',\n      content: 'Удалить',\n      placement: 'top',\n    }",
                modifiers: { html: true },
              },
            ],
            staticClass: "c-table-actions-trash",
            attrs: {
              size: "iconic",
              icon: { icon: "trash", color: "secondary" },
            },
            on: { click: _vm.openModalRemove },
          })
        : _vm._e(),
      _vm.record.code.value !== "driver" && Number(_vm.countWorkers) > 0
        ? _c("c-button", {
            directives: [
              {
                name: "b-tooltip",
                rawName: "v-b-tooltip.html",
                value: {
                  id: "positions-button-tooltip",
                  container: "#app",
                  trigger: "hover",
                  content: "Удалить",
                  title: "Удалить",
                  placement: "top",
                },
                expression:
                  "{\n      id: 'positions-button-tooltip',\n      container: '#app',\n      trigger: 'hover',\n      content: 'Удалить',\n      title: 'Удалить',\n      placement: 'top',\n    }",
                modifiers: { html: true },
              },
            ],
            staticClass: "c-table-actions-trash c-table-actions-trash-disabled",
            attrs: {
              id: `disable-delete-post-${_vm.postCode}`,
              size: "iconic",
              icon: { icon: "trash", color: "secondary" },
            },
          })
        : _vm._e(),
      _c(
        "b-popover",
        {
          ref: "popover",
          attrs: {
            target: `bonus-actions-${_vm.postCode}`,
            placement: "bottomleft",
            triggers: "click blur",
          },
        },
        [
          _c("div", { staticClass: "c-table-actions__actions__popover" }, [
            _c(
              "div",
              {
                staticClass: "c-table-actions__actions__popover-item",
                on: {
                  click: function ($event) {
                    return _vm.goToUpdatePostTest(_vm.record.code.value)
                  },
                },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "c-table-actions__actions__popover-item__icon",
                  },
                  [
                    _c(
                      "svg",
                      {
                        attrs: {
                          width: "14",
                          height: "14",
                          viewBox: "0 0 14 14",
                          fill: "none",
                          xmlns: "http://www.w3.org/2000/svg",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            d: "M9.33943 1.62805L8.63232 0.920947L8.63232 0.920948L9.33943 1.62805ZM10.8557 1V0V1ZM13 3.14431H14H13ZM12.3719 4.66057L11.6648 3.95346L11.6648 3.95346L12.3719 4.66057ZM5.16971 11.8628L5.43283 12.8276C5.60073 12.7818 5.75376 12.693 5.87682 12.5699L5.16971 11.8628ZM1 13L0.0352364 12.7369C-0.0591854 13.0831 0.0391427 13.4534 0.292893 13.7071C0.546642 13.9609 0.916904 14.0592 1.26312 13.9648L1 13ZM2.13719 8.8303L1.43009 8.12319C1.30703 8.24625 1.21822 8.39929 1.17243 8.56718L2.13719 8.8303ZM10.0465 2.33516C10.1528 2.2289 10.2789 2.14461 10.4178 2.08711L9.65241 0.239346C9.27093 0.397362 8.9243 0.62897 8.63232 0.920947L10.0465 2.33516ZM10.4178 2.08711C10.5566 2.0296 10.7054 2 10.8557 2V0C10.4428 0 10.0339 0.0813298 9.65241 0.239346L10.4178 2.08711ZM10.8557 2C11.006 2 11.1548 2.0296 11.2936 2.08711L12.059 0.239346C11.6775 0.0813296 11.2686 0 10.8557 0V2ZM11.2936 2.08711C11.4324 2.14461 11.5586 2.2289 11.6648 2.33516L13.0791 0.920947C12.7871 0.628971 12.4404 0.397363 12.059 0.239346L11.2936 2.08711ZM11.6648 2.33516C11.7711 2.44142 11.8554 2.56757 11.9129 2.7064L13.7607 1.94103C13.6026 1.55955 13.371 1.21292 13.0791 0.920947L11.6648 2.33516ZM11.9129 2.7064C11.9704 2.84523 12 2.99403 12 3.14431H14C14 2.7314 13.9187 2.32252 13.7607 1.94103L11.9129 2.7064ZM12 3.14431C12 3.29459 11.9704 3.44339 11.9129 3.58222L13.7607 4.34759C13.9187 3.9661 14 3.55722 14 3.14431H12ZM11.9129 3.58222C11.8554 3.72105 11.7711 3.8472 11.6648 3.95346L13.0791 5.36768C13.371 5.0757 13.6026 4.72907 13.7607 4.34759L11.9129 3.58222ZM11.6648 3.95346L4.46261 11.1557L5.87682 12.5699L13.0791 5.36767L11.6648 3.95346ZM4.9066 10.898L0.736884 12.0352L1.26312 13.9648L5.43283 12.8276L4.9066 10.898ZM1.96476 13.2631L3.10196 9.09342L1.17243 8.56718L0.0352364 12.7369L1.96476 13.2631ZM2.8443 9.53741L10.0465 2.33516L8.63232 0.920948L1.43009 8.12319L2.8443 9.53741ZM7 4L10 7L11.4142 5.58579L8.41421 2.58579L7 4Z",
                            fill: "#8E9CBB",
                          },
                        }),
                      ]
                    ),
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass: "c-table-actions__actions__popover-item-label",
                  },
                  [_vm._v(" Редактировать ")]
                ),
              ]
            ),
            _vm.isArchive === "0"
              ? _c(
                  "div",
                  {
                    staticClass: "c-table-actions__actions__popover-item",
                    on: { click: _vm.allowMoveToArchive },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "c-table-actions__actions__popover-item__icon",
                      },
                      [
                        _c(
                          "svg",
                          {
                            attrs: {
                              width: "17",
                              height: "15",
                              viewBox: "0 0 17 15",
                              fill: "none",
                              xmlns: "http://www.w3.org/2000/svg",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                d: "M1 5H0V6H1V5ZM16 5V6H17V5H16ZM2 5V4H1V5H2ZM15 5H16V4H15V5ZM7 7C6.44772 7 6 7.44772 6 8C6 8.55228 6.44772 9 7 9V7ZM10 9C10.5523 9 11 8.55228 11 8C11 7.44772 10.5523 7 10 7V9ZM14.5003 0H2.4997V2H14.5003V0ZM2.4997 0C1.12273 0 0 1.11598 0 2.49575H2C2 2.22552 2.22232 2 2.4997 2V0ZM0 2.49575V5H2V2.49575H0ZM17 5V2.49575H15V5H17ZM17 2.49575C17 1.11598 15.8773 0 14.5003 0V2C14.7777 2 15 2.22552 15 2.49575H17ZM1 6H16V4H1V6ZM13.4997 13H3.50031V15H13.4997V13ZM3.50031 13C3.22221 13 3 12.7741 3 12.5043H1C1 13.8844 2.12339 15 3.50031 15V13ZM3 12.5043V5H1V12.5043H3ZM14 5V12.5043H16V5H14ZM14 12.5043C14 12.7741 13.7778 13 13.4997 13V15C14.8766 15 16 13.8844 16 12.5043H14ZM2 6H15V4H2V6ZM7 9H10V7H7V9Z",
                                fill: "#8E9CBB",
                              },
                            }),
                          ]
                        ),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "c-table-actions__actions__popover-item-label",
                      },
                      [_vm._v(" Переместить в архив ")]
                    ),
                  ]
                )
              : _vm._e(),
            _vm.isArchive === "1"
              ? _c(
                  "div",
                  {
                    staticClass: "c-table-actions__actions__popover-item",
                    on: { click: _vm.moveFromArchive },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "c-table-actions__actions__popover-item__icon",
                      },
                      [
                        _c(
                          "svg",
                          {
                            attrs: {
                              width: "16",
                              height: "14",
                              viewBox: "0 0 16 14",
                              fill: "none",
                              xmlns: "http://www.w3.org/2000/svg",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                d: "M9 13C12.3137 13 15 10.3137 15 7C15 3.68629 12.3137 1 9 1C5.68629 1 3 3.68629 3 7M1 7L3 9L5 7",
                                stroke: "#8E9CBB",
                                "stroke-width": "2",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                              },
                            }),
                          ]
                        ),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "c-table-actions__actions__popover-item-label",
                      },
                      [_vm._v(" Восстановить из архива ")]
                    ),
                  ]
                )
              : _vm._e(),
          ]),
        ]
      ),
      _vm.record.code.value !== "driver" && Number(_vm.countWorkers) > 0
        ? _c(
            "b-popover",
            {
              attrs: {
                id: "positions-disable-delete-popover",
                left: "",
                triggers: "click blur",
                target: `disable-delete-post-${_vm.postCode}`,
              },
            },
            [
              _c(
                "svg",
                {
                  staticClass: "b-popover-warning",
                  attrs: {
                    width: "14",
                    height: "14",
                    viewBox: "0 0 14 14",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                  },
                },
                [
                  _c("circle", {
                    attrs: {
                      cx: "7",
                      cy: "7",
                      r: "6.5",
                      fill: "white",
                      stroke: "#FF238D",
                    },
                  }),
                  _c("circle", {
                    attrs: { cx: "7", cy: "10", r: "1", fill: "#FF238D" },
                  }),
                  _c("rect", {
                    attrs: {
                      x: "6",
                      y: "3",
                      width: "2",
                      height: "5",
                      rx: "1",
                      fill: "#FF238D",
                    },
                  }),
                ]
              ),
              _c("div", { staticClass: "b-popover-text" }, [
                _c("p", [
                  _vm._v(
                    "Нельзя удалить должность, пока хотя бы один сотрудник относится к ней."
                  ),
                ]),
                _c(
                  "a",
                  {
                    staticClass: "b-popover-text-link",
                    on: {
                      click: function ($event) {
                        return _vm.goToEmployeesTable(_vm.record.code.value)
                      },
                    },
                  },
                  [_vm._v("Перейти к списку сотрудников")]
                ),
              ]),
              _c(
                "svg",
                {
                  staticClass: "b-popover-close",
                  attrs: {
                    width: "15",
                    height: "15",
                    viewBox: "0 0 15 15",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      d: "M10.6045 10.6087C10.2154 10.9977 9.58272 10.9958 9.19126 10.6043L3.53712 4.95155C3.14565 4.56008 3.14367 3.92737 3.5327 3.53835C3.92172 3.14932 4.55443 3.1513 4.9459 3.54277L10.6 9.19551C10.9915 9.58698 10.9935 10.2197 10.6045 10.6087Z",
                      fill: "#8E9CBB",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M10.6127 3.54158C10.2212 3.15011 9.58849 3.14813 9.19947 3.53716L3.53718 9.19945C3.14816 9.58847 3.15014 10.2212 3.54161 10.6127C3.93307 11.0041 4.56579 11.0061 4.95481 10.6171L10.6171 4.95478C11.0061 4.56576 11.0041 3.93305 10.6127 3.54158Z",
                      fill: "#8E9CBB",
                    },
                  }),
                ]
              ),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }